import React from "react";
import { getWatchLayers } from "@/data/watchRender";
import { useApp } from "@/context/AppContext";

/**
 * Renders the actual configured watch as four stacked, filtered photo
 * layers (strap → case → dial → hands). `config` uses the same shape as
 * everywhere else in the app: { case, dial, hands, strap }.
 *
 * Used by the configurator's "result" tab, the cart drawer and the
 * checkout summary, so a custom watch always shows its real
 * configuration instead of a generic placeholder image.
 */
export const WatchConfigPreview = ({ config, className = "", testId = "watch-config-preview" }) => {
  const { customOptions } = useApp();
  if (!config) return null;
  const layers = getWatchLayers(config, customOptions);

  return (
    <div className={`relative ${className}`} data-testid={testId}>
      <img
        src={layers.strap.src}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-contain pointer-events-none"
        style={{ filter: `${layers.strap.filter} drop-shadow(0 6px 14px rgba(0,0,0,0.5))` }}
      />
      <img
        src={layers.case.src}
        alt="SOMMET"
        className="absolute inset-0 w-full h-full object-contain"
        style={{ filter: `${layers.case.filter} drop-shadow(0 6px 14px rgba(0,0,0,0.55))` }}
      />
      <img
        src={layers.dial.src}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-contain pointer-events-none"
        style={{ filter: layers.dial.filter }}
      />
      <img
        src={layers.hands.src}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-contain pointer-events-none"
        style={{ filter: layers.hands.filter }}
      />
    </div>
  );
};
